import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class DealService {
    static getDeals(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`deals?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.deal.createdOn = parseDate(x.deal.createdOn);
                x.deal.updatedOn = parseDate(x.deal.updatedOn);
            });
            return w;
        }));
    }
    static fetchDeal(oid) {
        return BaseService.get(`deals/${oid}`).pipe(map(x => {
            x.payload.createdOn = parseDate(x.payload.createdOn);
            x.payload.updatedOn = parseDate(x.payload.updatedOn);
            return x;
        }));
    }
    static saveDeal(dto) {
        return BaseService.save(`deals`, dto);
    }
    static deleteDeal(oid) {
        return BaseService.delete(`deals/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Comments
    // ----------------------------------------------------------------------
    static getDealComments(dealId) {
        return BaseService.get(`deal-comments/${dealId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveDealComment(dto) {
        return BaseService.post(`deal-comments`, dto);
    }
    static deleteDealComment(oid) {
        return BaseService.delete(`deal-comments/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchDealCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`deals-combo/${selfId}?search=${qs}`);
    }
}
